module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "Vuely-toolbar",
    attrs: {
      "width": 250,
      "fixed": "",
      "app": ""
    }
  }, [_c('div', {
    staticClass: "d-custom-flex align-items-center navbar-left"
  }, [_c('div', {
    staticClass: "d-custom-flex ml-0 align-items-center pl-0"
  }, [_c('div', {
    staticClass: "pointer mr-4"
  }, [_c('a', {
    attrs: {
      "href": _vm.domainName
    }
  }, [_c('app-logo')], 1)]), _vm._v(" "), _c('v-menu', {
    staticClass: "quciklink-dropdown",
    attrs: {
      "offset-y": "",
      "origin": "left top",
      "z-index": "99",
      "content-class": "quciklink-dropdown",
      "transition": "slide-y-transition",
      "nudge-left": "30",
      "fixed": ""
    }
  }, [_c('div', {
    staticClass: "m-0 fw-500",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    slot: "activator"
  }, [_vm._v("keyboard_arrow_down")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('v-list', {
    staticClass: "dropdown-list"
  }, [_c('v-list-tile', {
    staticClass: "pointer"
  }, [_c('span', {
    staticClass: "fw-bold font-1x primary--text"
  }, [_vm._v(_vm._s(_vm.$t('right.sort')))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.fingByHot
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("whatshot")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('right.hot')))])], 1)]), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.fingByNew
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("fiber_new")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(_vm.$t('right.new')))])], 1)]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer"
  }, [_c('span', {
    staticClass: "fw-bold font-1x primary--text"
  }, [_vm._v(_vm._s(_vm.$t("right.hotTopics")))])]), _vm._v(" "), _vm._l((_vm.marketsList), function(market) {
    return _c('v-list-tile', {
      key: market.marketId,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          return _vm.findByMarkets(market)
        }
      }
    }, [_c('span', {
      staticClass: "font-15 fw-400 pointer"
    }, [_c('v-icon', {
      attrs: {
        "size": "20"
      }
    }, [_vm._v(_vm._s(market.icon))]), _vm._v(" "), _c('span', {
      staticClass: "ml-3"
    }, [_vm._v(_vm._s(market.name))])], 1)])
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "pointer",
    on: {
      "click": _vm.findByTelegramList
    }
  }, [_c('span', {
    staticClass: "font-15 fw-400 pointer"
  }, [_c('v-icon', [_vm._v("fab fa-telegram")]), _vm._v(" "), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v("IOB Telegram")])], 1)])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-4 upgrade-btn pointer",
    on: {
      "click": _vm.goIobots
    }
  }, [_vm._v("ioBots")]), _vm._v(" "), _c('div', {
    staticClass: "ml-4 upgrade-btn pointer",
    on: {
      "click": _vm.goIobfi
    }
  }, [_vm._v("iob.fi")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right v-breadcrumbs__item"
  }, [_c('v-btn', {
    staticClass: "full-screen ma-0 mr-2 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.gotoNewsTopic
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('right.industryNews'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("fas fa-poll-h")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "full-screen ma-0 mr-2 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.fingByHot
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.hot'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("trending_up")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "full-screen ma-0 pointer",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.fingByNew
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.new'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("equalizer")])], 1)], 1), _vm._v(" "), _c('span', [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "origin": "left top",
      "z-index": "99",
      "content-class": "notification-dropdown",
      "transition": "slide-y-transition",
      "nudge-top": "-10",
      "nudge-left": "30"
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.menu'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("apps")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('v-list', {
    staticClass: "dropdown-list"
  }, [_c('v-list-tile', {
    staticClass: "pl-3 mb-2 mt-2 pointer",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('foot.title'))
    }
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.texts), function(text) {
    return _c('v-list-tile', {
      key: text.name,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          return _vm.routerPage(text.code)
        }
      }
    }, [_c('span', {
      staticClass: "font-16"
    }, [_vm._v(_vm._s(_vm.$t(text.name)))])])
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "mt-1"
  }, [_c('span', {
    staticClass: "font-10"
  }, [_vm._v("IOB LLC © 2019. " + _vm._s(_vm.$t('foot.aLLRightsReserved')))])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-badge', {
    staticClass: "notification-dropdown ma-0 pointer font-12",
    attrs: {
      "overlap": ""
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function() {
        return [(_vm.notificationNum > 0) ? _c('span', [_vm._v(_vm._s(_vm.notificationNum))]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.gotoNotification
    }
  }, [_c('Tooltip', {
    attrs: {
      "content": _vm.$t('header.notifications'),
      "placement": "bottom"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("far fa-bell")])], 1)], 1)], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.showMenuSidebar
    },
    slot: "activator"
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary",
      "size": "30"
    }
  }, [(_vm.user != null && _vm.user.image != null) ? _c('img', {
    attrs: {
      "src": _vm.user.image,
      "alt": _vm.user.userName
    }
  }) : _c('span', {
    staticClass: "headline white--text"
  }, [_vm._v(_vm._s(_vm.user != null ? _vm.user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''))])])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.showMenuSidebar
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary",
      "title": "User"
    }
  }, [_vm._v("fas fa-user-circle")])], 1)], 1)]), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "Vuely-sidebar",
    attrs: {
      "hide-overlay": "",
      "fixed": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.isShowMenuSidebar),
      callback: function($$v) {
        _vm.isShowMenuSidebar = $$v
      },
      expression: "isShowMenuSidebar"
    }
  }, [_c('app-menu')], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "chat-sidebar-wrap",
    attrs: {
      "hide-overlay": "",
      "fixed": "",
      "right": "",
      "temporary": ""
    },
    model: {
      value: (_vm.isShowUserSearchSidebar),
      callback: function($$v) {
        _vm.isShowUserSearchSidebar = $$v
      },
      expression: "isShowUserSearchSidebar"
    }
  }, [_c('app-user-search')], 1), _vm._v(" "), _c('v-bottom-sheet', {
    attrs: {
      "hide-overlay": "",
      "persistent": ""
    },
    model: {
      value: (_vm.isShowCookieStatement),
      callback: function($$v) {
        _vm.isShowCookieStatement = $$v
      },
      expression: "isShowCookieStatement"
    }
  }, [_c('v-card', {
    staticClass: "text-center"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("header.cookieStatementMessage")) + "\n      "), _c('a', {
    on: {
      "click": _vm.goPrivacy
    }
  }, [_vm._v(_vm._s(_vm.$t("header.privacyPolicy")))]), _vm._v("\n      " + _vm._s(_vm.$t("common.punctuation.period")) + "\n      "), _c('v-btn', {
    attrs: {
      "outline": "",
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.dissmissCookieStatement
    }
  }, [_vm._v(_vm._s(_vm.$t("header.dismiss")))])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (this.$store.state.loginModal),
      callback: function($$v) {
        _vm.$set(this.$store.state, "loginModal", $$v)
      },
      expression: "this.$store.state.loginModal"
    }
  }, [_c('v-card', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('h2', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("header.login")))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "icon": "",
      "right": "",
      "color": "pink"
    },
    on: {
      "click": _vm.hideLoginModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-form', {
    ref: "formInline",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-login",
    attrs: {
      "label": _vm.$t('header.usernameHint'),
      "rules": _vm.userNameRules,
      "required": ""
    },
    on: {
      "on-enter": _vm.loginAuth_v2
    },
    model: {
      value: (_vm.formInline.userName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "userName", $$v)
      },
      expression: "formInline.userName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-login",
    attrs: {
      "label": _vm.$t('header.passwordHint'),
      "rules": _vm.passWordRules,
      "type": _vm.isShowPassword ? 'text' : 'password',
      "append-icon": _vm.isShowPassword ? 'visibility_off' : 'visibility',
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.isShowPassword = !_vm.isShowPassword
      }
    },
    model: {
      value: (_vm.formInline.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "passWord", $$v)
      },
      expression: "formInline.passWord"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.isSaveUser),
      callback: function($$v) {
        _vm.isSaveUser = $$v
      },
      expression: "isSaveUser"
    }
  }, [_c('div', {
    staticClass: "ml-2",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('header.rememberMe')) + "\n                      "), _c('span', {
    attrs: {
      "color": "primary--text",
      "right": ""
    },
    on: {
      "click": _vm.goPassword
    }
  }, [_c('span', {
    staticClass: "ml-5"
  }, [_vm._v(_vm._s(_vm.$t("header.forgotPassword")))]), _vm._v("?\n                      ")])])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "loading": _vm.loading,
      "dark": ""
    },
    on: {
      "click": _vm.loginAuth_v2
    }
  }, [_vm._v(_vm._s(_vm.$t("header.login")))])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('span', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$t("header.accountHint")) + "?")]), _vm._v(" "), _c('span', {
    staticClass: "caption primary--text pointer",
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t("header.signUp")))])])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Modal', {
    attrs: {
      "align": "center",
      "loading": _vm.authLoading,
      "mask-closable": false
    },
    model: {
      value: (_vm.loginAuthenticationModal),
      callback: function($$v) {
        _vm.loginAuthenticationModal = $$v
      },
      expression: "loginAuthenticationModal"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "20px",
      "letter-spacing": "0",
      "line-height": "30px",
      "height": "40px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalTitle")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalEnterHint")))]), _vm._v(" "), _c('v-form', {
    ref: "formAuthentication",
    staticClass: "mt-4 mb-4"
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "enter-code-login",
    attrs: {
      "counter": 6,
      "rules": _vm.randomCodeRules,
      "single-line": "",
      "outline": ""
    },
    model: {
      value: (_vm.formAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "randomCode", $$v)
      },
      expression: "formAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.formAuthentication.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "authenticationSecret", $$v)
      },
      expression: "formAuthentication.authenticationSecret"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintBefore")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x primary--text pointer",
    on: {
      "click": _vm.goLostGoogleAuthentication
    }
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintMiddle")))]), _vm._v(" "), _c('label', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("header.googleModalContactHintAfter")))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer",
      "align": "center"
    },
    slot: "footer"
  }, [_c('Button', {
    staticClass: "primary",
    on: {
      "click": _vm.modalCancel
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])]), _vm._v(" "), _c('Button', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.verityRandomCode('formAuthentication')
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.$t("common.verify")))])])], 1)], 1)], 1), _vm._v(" "), (!_vm.isLogin) ? _c('div', {
    staticClass: "welcomeWrapper mb-2"
  }, [_c('div', {
    staticClass: "welcomeBanner"
  }, [_c('div', {
    staticClass: "row primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "show-for-large"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-6 welcomePitch"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('header.analyst')))]), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('header.paidTitle'))
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "black--text pa-0",
    attrs: {
      "small": "",
      "color": "white"
    },
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('register.signUp')))])], 1), _vm._v(" "), _vm._m(1)])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center welcomeImage small-12 show-for-small-only"
  }, [_c('img', {
    staticClass: "heroImage",
    attrs: {
      "src": require("../../static/img/573x512.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center welcomeImage medium-6 show-for-medium"
  }, [_c('img', {
    staticClass: "heroImage",
    attrs: {
      "src": require("../../static/img/573x512.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-596f911f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 441
// module chunks = 0